<app-buttons (button_selected)="option_selector($event)"></app-buttons>
<app-grid [rowData]="rowData" [columnDefs]="columnDefs" [rowSelection]="'single'"></app-grid>

<ng-template #modal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" *ngIf="!_td.id">Nuevo documento</h4>
        <h4 class="modal-title" *ngIf="_td.id">Actualizar Tipo documento</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div class="card m-b-0">
            <ul class="nav nav-tabs profile-tab" role="tablist">
                <li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#account" role="tab">Tipo
                        documento</a></li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane active" id="account" role="tabpanel">
                    <app-tipo-documento-dialog [td]="_td" [show_cancel_button]=true
                        (close_modal)="modal.close('Cancelar')" (submit_form)="save_td($event)">
                    </app-tipo-documento-dialog>
                </div>
            </div>
        </div>
    </div>
</ng-template>